import React, { useState } from 'react';
import './ContactUs.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Simulate form submission
    setSubmitStatus('sending');
    
    setTimeout(() => {
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
      
      setTimeout(() => {
        setSubmitStatus('');
      }, 5000);
    }, 1500);
  };

  return (
    <div className="contact-us">
      <div className="page-header">
        <div className="container">
          <h1 className="page-title fade-in">Contact Us</h1>
          <p className="page-subtitle fade-in">
            We'd love to hear from you. Send us a message and we'll respond as soon as possible.
          </p>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Form */}
            <div className="contact-form-wrapper card fade-in">
              <h2 className="form-title">Send Us a Message</h2>
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="John Doe"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="john@example.com"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject *</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="How can we help you?"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Tell us more about your inquiry..."
                    rows="6"
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className={`btn btn-primary submit-btn ${submitStatus === 'sending' ? 'sending' : ''}`}
                  disabled={submitStatus === 'sending'}
                >
                  {submitStatus === 'sending' ? 'Sending...' : 'Send Message'}
                </button>

                {submitStatus === 'success' && (
                  <div className="success-message fade-in">
                    ✓ Thank you! Your message has been sent successfully. We'll get back to you soon.
                  </div>
                )}
              </form>
            </div>

            {/* Contact Information */}
            <div className="contact-info-wrapper">
              <div className="contact-info-card card fade-in" style={{animationDelay: '0.1s'}}>
                <div className="info-icon">📧</div>
                <h3 className="info-title">Email Us</h3>
                <p className="info-text">
                  <a href="mailto:info@connectnowtutor.com">info@connectnowtutor.com</a>
                </p>
                <p className="info-description">
                  Send us an email anytime and we'll respond within 24 hours.
                </p>
              </div>

              <div className="contact-info-card card fade-in" style={{animationDelay: '0.2s'}}>
                <div className="info-icon">📱</div>
                <h3 className="info-title">Call Us</h3>
                <p className="info-text">
                  <a href="tel:+1234567890">+1 (234) 567-890</a>
                </p>
                <p className="info-description">
                  Available Monday to Friday, 9 AM - 6 PM EST.
                </p>
              </div>

              <div className="contact-info-card card fade-in" style={{animationDelay: '0.3s'}}>
                <div className="info-icon">📍</div>
                <h3 className="info-title">Visit Us</h3>
                <p className="info-text">
                  123 Learning Street<br />
                  Education City, EC 12345
                </p>
                <p className="info-description">
                  Our office is open for visitors by appointment.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
